import React, { useState, useEffect, forwardRef } from "react";
import InfiniteScrollBase from "react-infinite-scroll-component";

const N_INITIAL_PAGE = 1;

const InfiniteScroll = forwardRef((props, ref) => {
    const { fnNext, children, nTotalPages, nDataLength, bStopPagination, bResetPage, ...rest } = props;
    const [nPage, fnSetNPage] = useState(N_INITIAL_PAGE);

    useEffect(() => {
        if (!nDataLength) fnSetNPage(N_INITIAL_PAGE);
    }, [nDataLength]);

    useEffect(() => {
        if (nPage !== 1) fnNext?.(nPage);
    }, [nPage]);

    useEffect(() => {
        if (bResetPage) fnSetNPage(N_INITIAL_PAGE);
    }, [bResetPage]);

    const fnHandleNext = () => fnSetNPage(prev => prev + 1);

    return (
        <InfiniteScrollBase
            ref={ref}
            next={fnHandleNext}
            hasMore={(nPage < (nTotalPages || 1) && !bStopPagination)}
            dataLength={nDataLength}
            scrollableTarget="html"
            {...rest}
        >
            {children}
        </InfiniteScrollBase>
    );
})

InfiniteScroll.displayName = "InfiniteScroll";

export default InfiniteScroll;